import { axiosInstance } from "@/api/client";
import type { SignupIntentWireValue } from "../store/signup-draft-store";
import type { SessionBootstrapResponse } from "./types";

export const fetchSessionBootstrap = async () => {
  const { data } =
    await axiosInstance.get<SessionBootstrapResponse>("/session/bootstrap");
  return data;
};

/**
 * Registra cosa l'utente è venuto a fare, quando il server non lo sa.
 *
 * Risponde col contesto di sessione ricalcolato — stessa forma di
 * `/session/bootstrap` — quindi il chiamante instrada leggendo `next_step`
 * invece di mappare a mano intento → destinazione. Il backend rifiuta con 409
 * se l'intento risulta già determinato.
 */
export const chooseSignupIntent = async (intent: SignupIntentWireValue) => {
  const { data } = await axiosInstance.post<SessionBootstrapResponse>(
    "/session/intent",
    { intent },
  );
  return data;
};
